<template>
  <div>
    <header>
      <Header />
    </header>
    <div>
      <div class="sessionMessageArea">
        <div v-if="!errorFlag" class="sessionMessage">
          東京カメラ部2021写真展 Online Exhibitionへのサインインに成功しました。<br>
          この状態で応援メッセージを書き込むと、名前の横に青いチェックマークが表示されます。<br>
          ※名前＝プロフィール欄に記載の出展者名です。<br>
          <br>
          「東京カメラ部 オンライン写真展システム」でサインアウトをするか、一定期間何の操作も行わなかった場合、サインイン状態が解除され、チェックマークつきの書き込みができなくなります（通常の書き込みは可能です）。<br>
        </div>
        <div v-else class="sessionMessage">
          サインイン情報の引き継ぎ処理に失敗しました<br />
          お手数ですが、画面を閉じて最初から操作をやり直してください。<br />
          <br />
          <button @click="close">閉じる</button>
        </div>
      </div><!-- /main-->
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import TokenUtil from '@/util/TokenUtil'
import { MeApi } from '../../api/'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer
  },
  data () {
    return {
      errorFlag: false
    }
  },
  computed: {
  },
  methods: {
    setTitleAndDescription (to) {
      document.title = to.meta.title ? to.meta.title : ''
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', to.meta.desc ? to.meta.desc : '')
    },
    // URLパラメータで渡された一時トークンから本物のトークンを取得してローカルストレージに保存
    // 通常発生しないが、トークン払い出しに失敗した場合は、エラー画面を表示
    async setOlphenToken () {
      // URLからトークンを取得
      const token = this.$route.query.temporary_token
      // 一時トークンから本物のトークンを取得
      await MeApi.exchangeToken(token)
        .then(async (result) => {
          TokenUtil.set(result.data.token) // 受賞者マイページから受け渡されたトークンを保存
        })
        .catch(() => {
          // エラーが発生した場合は、エラー画面を表示
          location.href = '/token_receive?errorFlag=true'
        })
    },
    close () {
      window.close()
    }
  },
  created () {
    // エラーフラグを取得
    this.errorFlag = this.$route.query.errorFlag
    // エラーが発生していない場合は、一時トークン取得処理を行う
    if (!this.errorFlag) this.setOlphenToken()
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.sessionMessageArea {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.sessionMessage {
  max-width: 540px;
  text-align: center;
  font-size: 1.5em;
  padding: 32px;
  margin: 32px 32px 64px 32px;
}
</style>